<template>
    <zen-message-modal
        :isOpen="isOpen"
        @close="$emit('close')"
        title="Webhook created"
        iconVariant="sky"
    >
        <template #icon>
            <zen-icon-token />
        </template>
        <template #body>
            <div class="space-y-3">
                <p class="text-sm text-taupe-700">
                    Copy this signing secret now — it will not be shown again.
                </p>
                <div
                    class="flex items-center gap-2 rounded-md border border-taupe-200 bg-taupe-50 px-3 py-2 font-mono text-sm break-all"
                >
                    <span class="flex-1 select-all">{{ secret }}</span>
                    <zen-button
                        type="button"
                        @click="$emit('copy')"
                        variant="secondary"
                        size="small"
                    >
                        {{ copied ? 'Copied!' : 'Copy' }}
                    </zen-button>
                </div>
            </div>
        </template>
        <template #buttons>
            <zen-button @click="$emit('close')" variant="primary">
                Done
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'WebhookCreatedModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        secret: {
            type: String,
            default: null,
        },
        copied: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'copy'],
}
</script>
